<template>
  <Message>
    <template v-for="(_, slotName) in $slots" #[slotName]="slotProps">
      <slot :name="slotName" v-bind="slotProps ?? {}" />
    </template>
  </Message>
</template>

<script setup lang="ts">
import type { MessageEmits, MessageProps } from "primevue";

import { Message } from "primevue";

import "./pMessage.css";

defineProps</* @vue-ignore */ MessageProps>();
defineEmits</* @vue-ignore */ MessageEmits>();
</script>
